import Footer from '../ui/Footer';
import { connect } from 'react-redux';

const mapStateToProps = (state, props) => 
  ({
    page: state.page,
    pages: state.pages,
    intl: props.intl,
    content: state.content,
  });

const Container = connect(mapStateToProps)(Footer);

export default Container;